import React from 'react'
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'

const Component = styled.div`
  margin-bottom: 35px;

  .lotImage {
    height: 300px;
  }

  .lotName {
    height: 56px;
  }

  .lotAddress {
    margin: 15px 0 5px;
    height: 24px;
    width: 75%;

    &.last {
      margin: 0 0 15px;
      width: 50%;
    }
  }

  .lotAbout {
    height: 48px;
  }

  .lotChooseParkingMethod {
    height: 30px;
    margin-bottom: 16px;
    width: 75%;
  }

  .lotParkingMethodButton {
    height: 44px;

    &.last {
      margin-top: 20px;
    }
  }

  .monthlyParking {
    height: 24px;
  }

  .monthlyParkingDescription {
    height: 64px;
    margin: 10px 0 20px;
  }
`

const Content = styled.div`
  padding-left: 16px;
  padding-right: 16px;
`

const Divisor = styled.hr`
  display: block;
  margin: 30px 0;
  width: 100%;
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.grayLight};
`

const Loading = () => (
  <Component>
    <Skeleton className="lotImage" count={1} />
    <Skeleton className="lotName" count={1} />
    <Content>
      <Skeleton className="lotAddress" count={1} />
      <Skeleton className="lotAddress last" count={1} />
      <Skeleton className="lotAbout" count={1} />
      <Divisor />
      <Skeleton className="lotChooseParkingMethod" count={1} />
      <Skeleton className="lotParkingMethodButton" count={1} />
      <Skeleton className="lotParkingMethodButton last" count={1} />
      <Divisor />
      <Skeleton className="monthlyParking" count={1} />
      <Skeleton className="monthlyParkingDescription" count={1} />
    </Content>
  </Component>
)

export default Loading
